import React from 'react';
import { CheckCircledIcon, Cross2Icon, CrossCircledIcon } from '@radix-ui/react-icons';
import type { ToastType } from '../../store/toastStore';
import './SuccessMessage.scss';

export interface SuccessMessageProps {
  type: ToastType;
  title: string;
  message: string;
  onClose: () => void;
}

export const SuccessMessage: React.FC<SuccessMessageProps> = ({
  type,
  title,
  message,
  onClose,
}) => {
  const isError = type === 'error';

  return (
    <div
      className={`success-message success-message--${type}`}
      role={isError ? 'alert' : 'status'}
      aria-live="polite"
    >
      {isError ? (
        <CrossCircledIcon className="success-message__icon" aria-hidden="true" />
      ) : (
        <CheckCircledIcon className="success-message__icon" aria-hidden="true" />
      )}
      <div className="success-message__copy">
        <strong>{title}</strong>
        <p>{message}</p>
      </div>
      <button
        type="button"
        className="success-message__close"
        onClick={onClose}
        aria-label="Dismiss notification"
      >
        <Cross2Icon />
      </button>
    </div>
  );
};
